import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { pricePerAcreOf } from "../lib/samplePricing";
import { labByKey } from "../lib/soilLabs";
import { useLabOrder } from "../stores/labOrderStore";

// The quote is the rate. Acres are multiplied locally, so a live acre change
// does not wait on another request. `field_id` is not looked up: the quote
// prices `config.acres`, and the screen multiplies the returned rate by the
// real acreage. A lab key the order menu does not know is not quoted, so it
// cannot inherit another lab's tier.
const RATE_STALE_MS = 5 * 60 * 1000;

export function useSamplingPricePerAcre(): number | null {
  const labKey = useLabOrder((s) => s.lab);
  const packageCode = useLabOrder((s) => s.labPackage);
  const lab = labByKey(labKey);
  const quote = useQuery({
    queryKey: ["sampling-quote", lab?.name ?? null, packageCode],
    enabled: lab != null,
    staleTime: RATE_STALE_MS,
    retry: false,
    queryFn: () =>
      api.quoteSampling({
        field_id: "pricing",
        config: {
          acres: 1,
          lab_name: lab?.name,
          lab_shortname: lab?.shortName,
          package_code: packageCode || undefined,
        },
      }),
  });
  if (!lab) return null;
  return pricePerAcreOf(quote.data?.selected_tier);
}
